export const SAN_FRANCISCO_HUB_PATH_IDENTIFIER = 'san-francisco';
export const DEFAULT_LANDING_PAGE_PATH = '/san-francisco/all';

export const FIFTY_STATES_ABBREVIATIONS = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
];

export const INBOX_SESSION_STORAGE_KEY = 'inbox-session-storage';
export const FROM_MOBILE_INBOX_SESSION_STORAGE_KEY =
  'from-mobile-inbox-session-storage';

export const TIMESTAMP_FORMAT = 'MMM D, YYYY h:mma';

export const DEAL_STATUS_LABEL = 'Deal Status';
